<template>
  <div class="attachment-view">
    <div class="attachment-content">
      <div class="attachment-thumbnail">
        <img v-if="isImage" :src="thumbnailUrl" alt="Attachment thumbnail" />
        <div v-else class="file-icon">
          <i class="fa fa-file"></i>
          <div class="file-extension" v-if="fileExtension">
            .{{ fileExtension }}
          </div>
        </div>
      </div>

      <div class="attachment-details">
        <div class="attachment-filename">
          <strong>{{ filename }}</strong>
        </div>
        <div class="attachment-action">
          {{ actionDescription }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { fileExtension } from '@/utils/file_helpers'
  import { humanizeFieldName } from '@/constants/audit_constants'

  export default {
    props: {
      audit: {
        type: Object,
        required: true
      }
    },

    computed: {
      filename() {
        return this.audit.medium?.filename || 'Unknown file'
      },

      fileExtension() {
        return fileExtension(this.filename)
      },

      contentType() {
        return this.audit.medium?.content_type
      },

      isImage() {
        return this.contentType?.startsWith('image/')
      },

      thumbnailUrl() {
        // We fetch medium info from the database for all actions including destroy
        return this.audit.medium?.small_thumb_url || null
      },

      actionDescription() {
        if (this.audit.action === 'create') {
          return `This attachment was added to the story.`
        } else if (this.audit.action === 'destroy') {
          return `This attachment was removed from the story.`
        } else if (this.audit.action === 'update') {
          const changes = Object.keys(this.audit.audited_changes || {})
            .filter(key => key !== 'medium_id')
            .map(key => humanizeFieldName(key))
          return changes.length > 0
            ? `Modified: ${changes.join(', ')}`
            : 'This attachment was modified.'
        }
        return ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  .attachment-view {
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
  }

  .attachment-content {
    display: flex;
    gap: 20px;
    align-items: flex-start;
  }

  .attachment-thumbnail {
    flex-shrink: 0;
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }

    .file-icon {
      text-align: center;
      color: #999;

      i {
        font-size: 48px;
        display: block;
        margin-bottom: 8px;
      }

      .file-extension {
        font-size: 14px;
        font-weight: bold;
        text-transform: uppercase;
      }
    }
  }

  .attachment-details {
    flex: 1;
    min-width: 0;
  }

  .attachment-filename {
    font-size: 16px;
    margin-bottom: 10px;
    word-break: break-word;
  }

  .attachment-action {
    color: #666;
    font-size: 14px;
    line-height: 1.5;
  }
</style>
